<template>
  <header
    class="header-expanded py-6 px-5 relative box-border w-full"
    :class="$dm('bg-white', 'dark:bg-slate-900')"
  >
    <div
      class="flex items-start"
      :class="[avatarUrl ? 'justify-between' : 'justify-end']"
    >
      <img
        v-if="avatarUrl"
        class="fixed-size-img mr-3"
        :src="avatarUrl"
        alt="Avatar"
      />


      <!-- <img
        v-if="avatarUrl"
        class="h-8 w-8 rounded-full mr-3"
        :src="avatarUrl"
        alt="Avatar"
      /> -->
      <!-- <img
         class="h-8 w-8  mr-3 image_wrap"
         fixed-size-img
           alt="Avatar"
        v-if="!avatarUrl"
        class="h-8 w-8 rounded-full mr-3"
        src="~/widget/assets/images/chat-icon.jpg"
        alt="Avatar"
      /> -->
      <header-actions :show-popout-button="showPopoutButton" />
    </div>
    <h2
      v-dompurify-html="introHeading"
      class="mt-5 text-wh mb-3 font-normal"
      :class="$dm('text-slate-900', 'dark:text-slate-50')"
    />
    <p
      v-dompurify-html="introBody"
      class="text-lg leading-normal"
      :class="$dm('text-slate-700', 'dark:text-slate-200')"
    />
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderActions from './HeaderActions';
import darkModeMixin from 'widget/mixins/darkModeMixin.js';

export default {
  name: 'ChatHeaderExpanded',
  components: {
    HeaderActions,
  },
  mixins: [darkModeMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    introHeading: {
      type: String,
      default: '',
    },
    introBody: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),
  },
};
</script>

<style scoped lang="scss">
@import '~widget/assets/scss/variables';
@import '~widget/assets/scss/mixins';

.fixed-size-img {
  height: 30px !important;
  width: 30px !important;
  border-radius: 50% !important;
}
.text-wh {
  // font-size: 1.875rem/* 30px */;
  font-size: 1.475rem /* 30px */;
}

.header-wrap {
  flex-shrink: 0;
  transition: max-height 300ms;
  z-index: 99;
  @include shadow-large;

  &.expanded {
    max-height: 16rem;
  }

  &.collapsed {
    max-height: 4.5rem;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 667px) {
    border-radius: 0;
  }
}
</style>
